export default {
  namespaced: true,
  state: {
    notification: null,
    timeout: null
  },
  mutations: {
    SET_NOTIFICATION(state, notification) {
      state.notification = notification
    },
    CLEAR_NOTIFICATION(state) {
      state.notification = null
    },
    SET_TIMEOUT(state, timeout) {
      state.timeout = timeout
    }
  },
  actions: {
    showNotification({ commit, state }, notification) {
      // Clear any existing timeout
      if (state.timeout) {
        clearTimeout(state.timeout)
        commit('SET_TIMEOUT', null)
      }

      // Set the new notification
      commit('SET_NOTIFICATION', notification)

      // Set up auto-dismiss if duration is provided
      if (notification.duration && notification.duration > 0) {
        const timeout = setTimeout(() => {
          commit('CLEAR_NOTIFICATION')
          commit('SET_TIMEOUT', null)
        }, notification.duration)
        commit('SET_TIMEOUT', timeout)
      }
    },
    clearNotification({ commit, state }) {
      if (state.timeout) {
        clearTimeout(state.timeout)
        commit('SET_TIMEOUT', null)
      }
      commit('CLEAR_NOTIFICATION')
    }
  },
  getters: {
    currentNotification: state => state.notification
  }
} 